import { useEffect } from "react";
import PropostaDetalhada from "src/framework/layouts/Main/PropostaDetalhada";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Proposta Detalhada"

const PropostaDetalhadaPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <PropostaDetalhada />
        </div>
      </div>
    </div>
  );
};

export { PropostaDetalhadaPage };